export const addSchemeCard = async (schemeCardData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addSchemeCard", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...schemeCardData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = schemeCardData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Scheme Card Response:', response);
    return jsonResponse;
};
export const updateSchemeCard = async (schemeCardId, schemeCardData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateSchemeCard", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: schemeCardId, ...schemeCardData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = schemeCardData;
        data.id = schemeCardId;
        jsonResponse.data = data;
    }
    console.log('Update Scheme Card Response:', response);
    return jsonResponse;
};
export const deleteSchemeCard = async (schemeCardId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteSchemeCard", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: schemeCardId})
    });
    return await response.json();
};
